import NextImage from '@/components/NextImage';
import EFPic from '@/components/UI/EFPic';
import EFClock from '@/components/UI/svg/WTB/EFClock';
import EFDownloadArrow from '@/components/UI/svg/WTB/EFDownloadArrow';
import EFDownloadPhone from '@/components/UI/svg/WTB/EFDownloadPhone';
import EFDownloadPicture from '@/components/UI/svg/WTB/EFDownloadPicture';
import EFGlobal from '@/components/UI/svg/WTB/EFGlobal';
import EFLocation from '@/components/UI/svg/WTB/EFLocation';
import EFPageArrow from '@/components/UI/svg/WTB/EFPageArrow';
import EFPhone from '@/components/UI/svg/WTB/EFPhone';
import { getOutlyingIslandsStores } from '@/constants/where-to-buy';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import RetailStorePanelH5 from './RetailStorePanelH5';

export default function WhereToBuyH5() {
    const { useLang, useRouter, useState, gtm } = useGlobal();
    const { t } = useLang('wheretobuy');
    const { locale } = useRouter();
    const [active, setActive] = useState(['us', 'ca'].includes(locale) ? 'certified_dealer' : 'retail');
    const [hoverActive, setHoverActive] = useState(false);

    // us 离岛门店卡片
    const storesAll = getOutlyingIslandsStores(locale);
    const [curPage1, setCurPage1] = useState(1);
    const PAGE_NUM = 3;
    const [stores, setStores] = useState(storesAll?.slice(PAGE_NUM * (curPage1 - 1), PAGE_NUM * curPage1));

    const onPrevPage1 = () => {
        if (curPage1 > 1) {
            window.scrollTo({ top: (window.innerWidth / 375) * 120 });
            setCurPage1(curPage1 - 1);
            setStores(storesAll.slice(PAGE_NUM * (curPage1 - 2), PAGE_NUM * (curPage1 - 1)));
        }
    };

    const onNextPage1 = () => {
        if (curPage1 < Math.ceil(storesAll.length / PAGE_NUM)) {
            window.scrollTo({ top: (window.innerWidth / 375) * 120 });
            setCurPage1(curPage1 + 1);
            setStores(storesAll.slice(PAGE_NUM * curPage1, PAGE_NUM * (curPage1 + 1)));
        }
    };

    // 品牌
    const brandsMap: any = {
        us: {
            country: 'United States',
            brands: [
                { img: ['/media/wheretobuy/offcial/h5/1.webp', '/media/wheretobuy/offcial/h5/1.png'], link: 'https://us.ecoflow.com/' },
                {
                    img: ['/media/wheretobuy/offcial/h5/2.webp', '/media/wheretobuy/offcial/h5/2.png'],
                    link: 'https://www.amazon.com/stores/EFECOFLOW/page/4BFF29AC-A220-4ABD-AFDC-9D612039F6A1?ref_=ast_bln',
                },
                { img: ['/media/wheretobuy/offcial/h5/3.webp', '/media/wheretobuy/offcial/h5/3.png'], link: 'https://www.rei.com/search?q=ECOFLOW' },
                {
                    img: ['/media/wheretobuy/offcial/h5/4.webp', '/media/wheretobuy/offcial/h5/4.png'],
                    link: 'https://www.homedepot.com/b/Outdoors-Outdoor-Power-Equipment-Generators-Portable-Power-Stations-Battery-Generators/EcoFlow/N-5yc1vZ2fkoqhoZndu/Ntk-elasticplus/Ntt-ecoflow?Ntx=mode+matchpartialmax&NCNI-5&visNavSearch=ecoflow',
                },
                { img: ['/media/wheretobuy/offcial/h5/5.webp', '/media/wheretobuy/offcial/h5/5.png'], link: 'https://www.costco.com/ecoflow-schedule.html' },
                { img: ['/media/wheretobuy/offcial/h5/6.webp', '/media/wheretobuy/offcial/h5/6.png'] },
                { img: ['/media/wheretobuy/offcial/h5/7.webp', '/media/wheretobuy/offcial/h5/7.png'], link: 'https://www.lowes.com/search?searchTerm=ecoflow' },
                { img: ['/media/wheretobuy/offcial/h5/8.webp', '/media/wheretobuy/offcial/h5/8.png'], link: 'https://www.tractorsupply.com/tsc/brand/EcoFlow' },
                { img: ['/media/wheretobuy/offcial/h5/9.webp', '/media/wheretobuy/offcial/h5/9.png'], link: 'https://www.target.com/s?searchTerm=EcoFlow' },
                {
                    img: ['/media/wheretobuy/offcial/h5/10.webp', '/media/wheretobuy/offcial/h5/10.png'],
                    link: 'https://www.bestbuy.com/site/searchpage.jsp?st=ecoflow&_dyncharset=UTF-8&_dynSessConf=&id=pcat17071&type=page&sc=Global&cp=1&nrp=&sp=&qp=&list=n&af=true&iht=y&usc=All+Categories&ks=960&keys=keys',
                },
                { img: ['/media/wheretobuy/offcial/h5/11.webp', '/media/wheretobuy/offcial/h5/11.png'], link: 'https://www.ebay.com/str/ecoflowofficial' },
                { img: ['/media/wheretobuy/offcial/h5/12.webp', '/media/wheretobuy/offcial/h5/12.png'], link: 'https://www.walmart.com/search?q=EF+EcoFlow' },
                {
                    img: ['/media/wheretobuy/offcial/h5/13.webp', '/media/wheretobuy/offcial/h5/13.png'],
                    // link: 'https://www.northerntool.com/shop/tools/NTESearch?storeId=6970&ipp=48&Ntt=ecoflow',
                    link: 'https://www.northerntool.com/brands/ecoflow',
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/20.webp', '/media/wheretobuy/offcial/pc/20.png'],
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/21.webp', '/media/wheretobuy/offcial/pc/21.png'],
                    link: 'https://www.harborfreight.com/search?q=EcoFlow',
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/22.webp', '/media/wheretobuy/offcial/pc/22.jpg'],
                    link: 'https://shopsolarkits.com/#/c2529e94-5ed2-4057-b71d-9332d34d96ca/embedded/autofilters=true&page=1&query=ECOFLOW&query_name=match_none&rpp=50',
                },
                {
                    img: ['/media/wheretobuy/offcial/pc/23.webp', '/media/wheretobuy/offcial/pc/23.jpg'],
                    link: 'https://www.wellbots.com/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&q=ecoflow',
                },
                {
                    img: ['https://websiteoss.ecoflow.com/upload/image/1749526654320/campervanhq.png'],
                    link: 'https://www.campervan-hq.com/',
                },
            ],
        },
        'us-vi': {
            country: 'U.S. Virgin Islands',
            brands: [
                {
                    img: ['/media/wheretobuy/offcial/h5/25.png', '/media/wheretobuy/offcial/h5/25.png'],
                    link: 'https://backitups.com/ols/categories/ecoflow',
                    isArea: true,
                },
            ],
        },
        ca: {
            country: 'Canada',
            brands: [
                { img: ['/media/wheretobuy/offcial/h5/1.webp', '/media/wheretobuy/offcial/h5/1.png'], link: 'https://ca.ecoflow.com/' },
                {
                    img: ['/media/wheretobuy/offcial/h5/14.webp', '/media/wheretobuy/offcial/h5/14.png'],
                    link: 'https://www.amazon.ca/stores/EFECOFLOW/page/20C3DB9D-74BA-4AE9-93C4-D888FC16B7F4?ref_=ast_bln',
                },
                {
                    img: ['/media/wheretobuy/offcial/h5/10.webp', '/media/wheretobuy/offcial/h5/10.png'],
                    link: 'https://www.bestbuy.ca/en-ca/search?search=EcoFlow',
                },
                {
                    img: ['/media/wheretobuy/offcial/h5/5.webp', '/media/wheretobuy/offcial/h5/5.png'],
                    link: 'https://www.costco.ca/s?langId=-24&keyword=EcoFlow',
                },
                // {
                //     img: ['/media/wheretobuy/offcial/h5/15.webp', '/media/wheretobuy/offcial/h5/15.png'],
                //     link: 'https://modularacks.com/pages/search-results-page?q=ecoflow',
                // },
                // {
                //     img: ['/media/wheretobuy/offcial/pc/21.webp', '/media/wheretobuy/offcial/pc/21.png'],
                //     link: 'https://www.harborfreight.com/search?q=EcoFlow',
                // },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload/image/1754028410408/shop%20solar.png',
                        'https://websiteoss.ecoflow.com/upload/image/1754028410408/shop%20solar.png',
                    ],
                    link: 'https://shopsolarkits.com/collections/ecoflow',
                },
                // {
                //     img: ['/media/wheretobuy/offcial/pc/23.webp', '/media/wheretobuy/offcial/pc/23.jpg'],
                //     link: 'https://www.wellbots.com/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&q=ecoflow',
                // },
                {
                    img: ['/media/wheretobuy/offcial/pc/24.webp', '/media/wheretobuy/offcial/pc/24.png'],
                    link: 'https://www.tsc.ca/pages/productresults?dimensions=3004108&rd=1&searchterm=ecoflow',
                },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload/image/1721180874609/20240716-161107.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1721180874609/20240716-161107.jpg',
                    ],
                    link: 'https://www.batteriesexpert.com/product_search/?q=EcoFlow',
                },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload/image/1754028410090/Canadian_Tire_logo_2022.png',
                        'https://websiteoss.ecoflow.com/upload/image/1754028410090/Canadian_Tire_logo_2022.png',
                    ],
                    link: 'https://www.canadiantire.ca/en/search-results.html?q=EcoFlow',
                },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload/image/1754028410625/londondrugs.png',
                        'https://websiteoss.ecoflow.com/upload/image/1754028410625/londondrugs.png',
                    ],
                    link: 'https://www.londondrugs.com/search?q=EcoFlow&autoFiltersApplied=true',
                },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload//1754028410164/craze%20outdoor%20logo.avif',
                        'https://websiteoss.ecoflow.com/upload//1754028410164/craze%20outdoor%20logo.avif',
                    ],
                    link: 'https://crazeoutdoors.com/collections/ecoflow?srsltid=AfmBOop8rGGys8_qvsEi0USH12qBCyqzyx5AUZ8N7ZHvJu4cWrSexdhD',
                },
                {
                    img: [
                        'https://websiteoss.ecoflow.com/upload/image/1760065838731/1667945785696%20(1).jpeg',
                        'https://websiteoss.ecoflow.com/upload/image/1760065838731/1667945785696%20(1).jpeg',
                    ],
                    link: 'https://truoffgrid.com/shop',
                },
            ],
        },
        cn: {
            country: '中国',
            brands: [
                { img: ['/media/wheretobuy/offcial/h5/16.webp', '/media/wheretobuy/offcial/h5/16.png'], link: 'https://u.jd.com/xMUCTB1' },
                { img: ['/media/wheretobuy/offcial/h5/19.webp', '/media/wheretobuy/offcial/h5/19.png'], link: 'https://u.jd.com/xMUL3UY' },
                {
                    img: ['/media/wheretobuy/offcial/h5/18.webp', '/media/wheretobuy/offcial/h5/18.png'],
                    bigImg: {
                        img: ['/media/wheretobuy/offcial/h5/18_hover.webp', '/media/wheretobuy/offcial/h5/18_hover.png'],
                        title: t('douyin_title'),
                        desc: t('douyin_desc'),
                        note: [
                            {
                                icon: <EFDownloadPicture width="0.26rem" height="0.26rem" />,
                                text: t('download_savePic'),
                            },
                            {
                                icon: <EFDownloadPhone width="0.26rem" height="0.26rem" />,
                                text: t('download_phone'),
                            },
                        ],
                    },
                },
                {
                    img: ['/media/wheretobuy/offcial/h5/17.webp', '/media/wheretobuy/offcial/h5/17.png'],
                    link: 'https://ecoflow.tmall.com/?spm=a220o.1000855.1997427721.d4918089.37a29352j6oQdE',
                },
            ],
        },
        'cn-hk': {
            country: 'China',
            brands: [
                {
                    img: ['https://websiteoss.ecoflow.com/upload/image/1762497356232/1.jpeg'],
                    link: 'https://www.futex.hk/',
                },
            ],
        },
    };
    const brandListsCur = brandsMap[locale] || [];
    const onBrandClick = (brand: any) => {
        if (brand?.link) {
            window.open(brand?.link, '_blank');
        }
        if (brand?.bigImg && Object.keys(brand?.bigImg)?.length > 0) {
            setHoverActive(!hoverActive);
        }
    };

    const onClickTab = (tab: string, tabText: string) => {
        active !== tab && setActive(tab);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('title'),
            button_name: tabText,
        });
    };

    return (
        <div className={`whereToBuy_h5 ${css.whereToBuy_h5}`}>
            <h1 className="title"> {t('title')}</h1>
            <div className="subTitle"> {t('subTitle')}</div>
            <div className="tabsContainer">
                {['us', 'cn', 'ca'].includes(locale) && (
                    <div className="tabs">
                        {['us', 'ca'].includes(locale) && (
                            <li
                                className={`${active === 'certified_dealer' ? 'active' : ''} tab_item`}
                                onClick={() => onClickTab('certified_dealer', t('tab_certified_dealer'))}
                            >
                                <span className="text">{t('tab_certified_dealer')}</span>
                            </li>
                        )}
                        {['us', 'cn', 'ca'].includes(locale) && (
                            <li className={`${active === 'retail' ? 'active' : ''} tab_item`} onClick={() => onClickTab('retail', t('tab_retailStore'))}>
                                <span className="text">{t('tab_retailStore')}</span>
                            </li>
                        )}
                        {['us', 'cn', 'ca'].includes(locale) && (
                            <li
                                className={`${active === 'offcial' ? 'active' : ''} tab_item`}
                                onClick={() => onClickTab('offcial', t('tab_offcialOnlineStores'))}
                            >
                                <span className="text">{t('tab_offcialOnlineStores')}</span>
                            </li>
                        )}
                        {['us', 'ca'].includes(locale) && (
                            <li className={`${active === 'PR_HI_VK' ? 'active' : ''} tab_item`} onClick={() => onClickTab('PR_HI_VK', t('tab_PR_HI_VK'))}>
                                <span className="text">{t('tab_PR_HI_VK')}</span>
                            </li>
                        )}
                    </div>
                )}
                {['us', 'ca'].includes(locale) && <RetailStorePanelH5 visible={active === 'certified_dealer'} typeCode="2" />}
                <RetailStorePanelH5 visible={active === 'retail'} typeCode={['us', 'ca'].includes(locale) ? '1' : undefined} />
                <div className={`offcailOnlineStores ${active === 'offcial' ? 'active' : ''}`}>
                    {Object.keys(brandListsCur)?.length > 0 && (
                        <ul className="brands">
                            <div className="countryName">
                                <div className="country">{brandListsCur?.country}</div>
                            </div>
                            {brandListsCur?.brands?.map((brand: any, k: number) => (
                                <li className={`brandList ${brand?.link ? '' : 'noLink'}`} key={`curCountry_${k}`} onClick={() => onBrandClick(brand)}>
                                    <EFPic src={brand?.img} alt="" aria-label="" />
                                    {brand?.bigImg && (
                                        <div className={`brandHoverBox ${hoverActive ? 'active' : ''}`}>
                                            <div className="hoverImg">
                                                <EFPic src={brand?.bigImg?.img} alt={brand?.bigImg?.title} aria-label={brand?.bigImg?.title} />
                                            </div>
                                            <p className="hoverTitle">{brand?.bigImg?.title}</p>
                                            <p className="hoverDesc">{brand?.bigImg?.desc}</p>
                                            <div className="noteBox">
                                                {brand?.bigImg?.note?.map((noteItem: any, m: number) => (
                                                    <div className="noteItem" key={m}>
                                                        <div className="noteIcon">{noteItem?.icon}</div>
                                                        <div className="noteText">{noteItem.text}</div>
                                                        {m === 0 && (
                                                            <div className="noteArrow">
                                                                <EFDownloadArrow width="0.16rem" height="0.1rem" />
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </li>
                            ))}
                        </ul>
                    )}
                    {locale !== 'cn' &&
                        Object.keys(brandsMap)
                            ?.filter((key: string) => key !== locale && key !== 'cn' && brandsMap[key]?.brands?.length > 0)
                            ?.map((country: any) => (
                                <ul className="brands" key={`otherCountry_${country}`}>
                                    <div className="countryName">
                                        <div className="country">{brandsMap[country]?.country}</div>
                                    </div>
                                    {brandsMap[country]?.brands?.map((brand: any, k: number) => (
                                        <li
                                            className={`brandList ${brand?.link ? '' : 'noLink'}`}
                                            key={`${country}_brand_${k}`}
                                            onClick={() => onBrandClick(brand)}
                                        >
                                            <EFPic src={brand?.img} alt="" aria-label="" />
                                        </li>
                                    ))}
                                </ul>
                            ))}
                </div>
                <div className={`PRHIVKBox ${active === 'PR_HI_VK' ? 'active' : ''}`}>
                    <div className="PRHIVK">
                        <ul className="store-lists">
                            {stores?.map((store: any, k: number) => (
                                <li className="store-list" key={k}>
                                    <div className="list-img-box">
                                        <NextImage
                                            src={require(`@publicLocal/where-to-buy/h5/${store.img}`)}
                                            alt={store.storeName}
                                            aria-label={store.storeName}
                                            placeholder="blur"
                                        />
                                        <p className="list-state">{store.state}</p>
                                    </div>
                                    <div className="list-text-box">
                                        <p className="list-store-name">{store.storeName}</p>
                                        {store?.address && !store?.virtualFlag && (
                                            <div className="store-address common">
                                                <div className="icon">
                                                    <EFLocation />
                                                </div>
                                                {store?.address.trim().startsWith('https://') ? (
                                                    <a className="text" href={store?.link} target="_blank" rel="noreferrer">
                                                        {store?.address}
                                                    </a>
                                                ) : (
                                                    <div className="text">{store?.address}</div>
                                                )}
                                            </div>
                                        )}
                                        {store?.tel && (
                                            <div className="store-tel common">
                                                <div className="icon">
                                                    <EFPhone />
                                                </div>
                                                <a className="text" href={`tel:${store?.tel}`}>
                                                    {store?.tel}
                                                </a>
                                            </div>
                                        )}
                                        {store?.link && (
                                            <div className="store-link common">
                                                <div className="icon">
                                                    <EFGlobal />
                                                </div>
                                                <a className="text" href={store?.link} target="_blank" rel="noreferrer">
                                                    {store?.link}
                                                </a>
                                            </div>
                                        )}
                                        {store?.time && (
                                            <div className="store-time common">
                                                <div className="icon">
                                                    <EFClock />
                                                </div>
                                                <div className="text">{store?.time}</div>
                                            </div>
                                        )}
                                    </div>
                                </li>
                            ))}
                        </ul>
                        {stores?.length > 0 && (
                            <div className="pagenation">
                                <div className={`left-icon ${curPage1 === 1 ? 'disable' : ''}`} onClick={onPrevPage1}>
                                    <EFPageArrow />
                                </div>
                                <div className="middle-box">
                                    <span className="pages">
                                        {curPage1}/{Math.ceil(storesAll.length / PAGE_NUM)}
                                    </span>
                                    <span className="total">
                                        {storesAll.length === 1
                                            ? t.rich('total_single', {
                                                  total: storesAll.length,
                                              })
                                            : t.rich('total', {
                                                  total: storesAll.length,
                                              })}
                                    </span>
                                </div>
                                <div className={`right-icon ${curPage1 === Math.ceil(storesAll.length / PAGE_NUM) ? 'disable' : ''}`} onClick={onNextPage1}>
                                    <EFPageArrow />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
